import React from "react";
import { Box, Text, VStack, useMediaQuery } from "@chakra-ui/react";
import intro from "../../../../data/intro.json";
import introLanding from "../../../../data/introLanding.json";
import { formatTextWithLineBreaks } from "../../../../utils/formatText";
import { convertToEmbedUrl } from "../../../../helpers/youtubeHelper";

function Intro({ homepage, video }) {
  // Check if the screen width is 425px or less
  const [isMobile] = useMediaQuery("(max-width: 425px)");
  const content = homepage ? intro : introLanding;

  return (
    <Box
      id="intro"
      p={5}
      textAlign="center"
      borderRadius="lg"
      boxShadow="lg"
      className="intro"
    >
      <VStack spacing={4}>
        <Box
          bg="rgba(244, 240, 237, 0.9)"
          boxShadow="0px 4px 6px rgba(0, 0, 0, 0.2)"
          borderRadius="10px"
          p={2}
        >
          <Text
            fontSize={{ base: "1rem", md: "1.2rem" }}
            color={{ base: "#020717" }}
            fontWeight="600"
            dir="rtl"
          >
            <b>{formatTextWithLineBreaks(content.title)}</b>
          </Text>
          <Box height="1rem" />
          {content.bold && (
            <Text
              fontSize={{ base: "1rem", md: "1.2rem" }}
              color={{ base: "#020717" }}
              fontWeight="400"
              dir="rtl"
              mb={2}
            >
              <b>{formatTextWithLineBreaks(content.bold)}</b>
            </Text>
          )}
          {content.paragraphs.map((paragraph, index) => (
            <React.Fragment key={index}>
              {index !== 0 && <Box height="1rem" />}
              <Text
                fontSize={{ base: "1rem", md: "1.2rem" }}
                color={{ base: "#020717" }}
                fontWeight="400"
                dir="rtl"
              >
                {formatTextWithLineBreaks(paragraph)}
              </Text>
            </React.Fragment>
          ))}
        </Box>

        {!isMobile && (
          <Box
            width={{ base: "100%", md: "100%", lg: "100%" }}
            height={{ base: "30vh", md: "45vh", lg: "52vh" }}
          >
            <iframe
              width="100%"
              height="100%"
              src={convertToEmbedUrl(video.url)}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media;gyroscope; picture-in-picture;web-share"
              allowFullScreen
            ></iframe>
          </Box>
        )}
      </VStack>
    </Box>
  );
}

export default Intro;
